/**
 * XUniqueSorted.
 *
 * @param array - Array of number.
 * @returns Sorted array.
 */
export function xUniqueSorted(array) {
    return Float64Array.from(new Set(array)).sort();
}
//# sourceMappingURL=xUniqueSorted.js.map